import classnames from 'classnames';
import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isMultiCity } from '../../../store/segments/selectors';
import { useTheme } from '../../../../theme';
import { useConfig } from '../../../../context';
import { getHasPassengersErrors, getTotalPassengersCount } from '../../../store/passengers/selectors';
import { useForm } from 'react-final-form';
import { default as BaseButton } from '../../../../BaseComponents/Button';
import { CdnIcon } from '@shared/ui';
const StartSearch = React.memo(props => {
    const { StartSearch: css } = useTheme('SearchForm');
    const { t } = useTranslation('SearchForm');
    const hasPassengersErrors = useSelector(getHasPassengersErrors);
    const { resumeValidation } = useForm();
    const { SearchForm: { proMode } } = useConfig();
    return (React.createElement("div", { className: classnames(css.startSearch, {
            [css.startSearch_iconMode]: props.mode === 'icon',
            [css.startSearch_multiCity]: props.isMultiCity,
            [css.startSearch_advanced]: proMode
        }) },
        React.createElement(BaseButton, { type: "submit", variant: "smallPrimary", disabled: hasPassengersErrors, onClick: resumeValidation }, props.mode === 'icon' ? (React.createElement(CdnIcon, { icon: 'Action/Search' })) : (React.createElement("span", null,
            " ",
            t('Search'),
            " ")))));
});
const mapStateToProps = (state, props) => {
    return Object.assign(Object.assign({}, props), { isMultiCity: isMultiCity(state), passengersCount: getTotalPassengersCount(state) });
};
export default connect(mapStateToProps)(StartSearch);
